export default "__VITE_ASSET__b67d813a__$_?react__"